module.exports = __webpack_public_path__ + "static/media/20200404_062147.c5672600.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20200404_062147.gif
// module id = 232
// module chunks = 0